import request from '../servises/request'

export function getManualTinderScans(params) {
  return request({
    url: params ? `/manual-tinder-scan?${params}` : '/manual-tinder-scan',
    method: 'GET'
  })
}

export function createManualTinderScan(data) {
  return request({
    url: '/manual-tinder-scan',
    method: 'POST',
    data: data
  })
}

export function showManualTinderScan(id) {
  return request({
    url: `/manual-tinder-scan/${id}`,
    method: 'GET'
  })
}

export function toggleRepeatable(id) {
  return request({
    url: `/manual-tinder-scan/${id}/toggle-repeatable`,
    method: 'PATCH'
  })
}

export function rescanManualTinderScan(id) {
  return request({
    url: `/manual-tinder-scan/${id}/rescan`,
    method: 'POST'
  })
}
